import { GetCurrentCountriesApiParameter } from "@insite/client-framework/Services/WebsiteService";
import loadCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCountries";

export const loadAllCountriesParameter: GetCurrentCountriesApiParameter = {
    expand: ["states"],
    additionalExpands: ["all"],
};

const loadAllCountries = () => loadCountries(loadAllCountriesParameter);
export default loadAllCountries;
